import { useContext, useState } from "react";
import { ModalAlertContext } from "../../contexts/ModalAlertContext";
import './index.css';
import { selfixSmallLogoIcon } from "../../assets";
import { TextArea } from "../TextArea";
import CallStore from "../../stores/CallStore";
import { useNavigate } from "react-router";
import strings from "../../localization";
import { DomPurifyHtml } from "../DomPurifyHtml";


const starSvgString = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_371_48214" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="1" width="22" height="21">
    <path d="M11.6615 2.33299C11.7127 2.2098 11.8873 2.2098 11.9385 2.33299L14.6215 8.78358C14.6431 8.83552 14.6919 8.871 14.748 8.8755L21.7119 9.4338C21.8449 9.44446 21.8988 9.61044 21.7975 9.69724L16.4917 14.2422C16.449 14.2788 16.4303 14.3362 16.4434 14.3909L18.0644 21.1866C18.0954 21.3164 17.9542 21.4189 17.8403 21.3494L11.8782 17.7078C11.8302 17.6784 11.7698 17.6784 11.7218 17.7078L5.75969 21.3494C5.64583 21.4189 5.50464 21.3164 5.5356 21.1866L7.15661 14.3909C7.16966 14.3362 7.151 14.2788 7.10828 14.2422L1.80248 9.69724C1.70115 9.61044 1.75508 9.44446 1.88808 9.4338L8.85204 8.8755C8.90811 8.871 8.95695 8.83552 8.97855 8.78358L11.6615 2.33299Z" fill="black" stroke="black"/>
  </mask>
  <g mask="url(#mask0_371_48214)">
    <rect x="1" y="1" width="1" height="22" fill="black"/>
    <path d="M11.6615 2.33299C11.7127 2.2098 11.8873 2.2098 11.9385 2.33299L14.6215 8.78358C14.6431 8.83552 14.6919 8.871 14.748 8.8755L21.7119 9.4338C21.8449 9.44446 21.8988 9.61044 21.7975 9.69724L16.4917 14.2422C16.449 14.2788 16.4303 14.3362 16.4434 14.3909L18.0644 21.1866C18.0954 21.3164 17.9542 21.4189 17.8403 21.3494L11.8782 17.7078C11.8302 17.6784 11.7698 17.6784 11.7218 17.7078L5.75969 21.3494C5.64583 21.4189 5.50464 21.3164 5.5356 21.1866L7.15661 14.3909C7.16966 14.3362 7.151 14.2788 7.10828 14.2422L1.80248 9.69724C1.70115 9.61044 1.75508 9.44446 1.88808 9.4338L8.85204 8.8755C8.90811 8.871 8.95695 8.83552 8.97855 8.78358L11.6615 2.33299Z" stroke="black" stroke-width="1.5"/>
  </g>
</svg>
`;

const ThankYouScreen = () => {
  const navigate = useNavigate();
  const { closeRateOurServiceAlert } = useContext(ModalAlertContext);

  const slug = CallStore.call?.slug;

  const handleGoToSessionLog = () => {
    closeRateOurServiceAlert();
    window.location = `/tech/session/${slug}`;
  }

  const handleGoToDashboard = () => {
    closeRateOurServiceAlert();
    window.location = `/tech/dashboard`;
  }

  return (
    <div className="rate-our-service-alert-content">
      <img src={selfixSmallLogoIcon} alt="logo" className="rate-our-service-alert-content-logo" />

      <div className="rate-our-service-alert-content-title">
        <h1>{strings.thankYou}</h1>
        <p>{strings.thanksForYourTimeForReview}</p>
      </div>

      <div className="rate-our-service-alert-content-thank-you-buttons">
        <button className="button-cta-secondary button-cta-secondary-medium"
          onClick={handleGoToSessionLog}
        >
          <span>{strings.goToSessionLog}</span>
        </button>
        <button className="button-cta button-cta-medium"
          onClick={handleGoToDashboard}
        >
          <span>{strings.goToDashboard}</span>
        </button>
      </div>
    </div>
  );
}

export const RateOurServiceAlert = () => {
  const { rateOurServiceAlert, showModalAlert, closeModalAlert, closeRateOurServiceAlert, showRateOurServiceAlert } = useContext(ModalAlertContext);
  const [feedback, setFeedback] = useState('');
  const [rating, setRating] = useState(0);
  const [screen, setScreen] = useState('rate');
  if (!rateOurServiceAlert) return null;


  const handleSubmit = () => {
    CallStore.rateService(CallStore.slug, {
      comment: feedback,
      rating: rating
    }).then((response) => {
      if (response.success) {
        setScreen('thank-you');
      } else {
        closeRateOurServiceAlert();
        showModalAlert({
          title: strings.error,
          message: response.message,
          type: "error",
          onConfirm: () => {
            closeModalAlert();
            showRateOurServiceAlert();
            setScreen('thank-you');
          },
          onCancel: null
        });
      }
    });
  }

  return (
    <div className="rate-our-service-alert">
      {screen === 'rate' && (
        <div className="rate-our-service-alert-content">
          <img src={selfixSmallLogoIcon} alt="logo" className="rate-our-service-alert-content-logo" />

          <div className="rate-our-service-alert-content-title">
            <h1>{strings.rateYourService}</h1>
            <p>{strings.heyTechnicianPleaseRateOurService}</p>
          </div>

          <div className="rate-our-service-alert-content-feedback">
            <TextArea label={strings.yourFeedbacks} placeholder={strings.enterYourFeedbackHere} value={feedback} onChange={setFeedback} />
          </div>

          <div className="rate-our-service-alert-content-rating">
            {Array.from({ length: 5 }).map((_, index) => (
              <DomPurifyHtml
                key={index}
                onClick={() => setRating(index + 1)}
                className={`rate-our-service-alert-content-rating-star ${rating >= index + 1 ? "rate-our-service-alert-content-rating-star-active" : ""}`}
                html={starSvgString}
              />
            ))}
          </div>

          <button
            className="button-cta-secondary button-cta-secondary-medium rate-our-service-alert-content-submit" disabled={!rating}
            onClick={handleSubmit}
          >
            <span>{strings.submit}</span>
          </button>
        </div>
      )}
      {screen === 'thank-you' && (
        <ThankYouScreen />
      )}
    </div>
  );
};